export default {
  root: '/',
  main: '/ui',
  about: '/ui/about',
  contacts: '/ui/contacts',
  banks: '/ui/banks',
  bankApplication: '/ui/banks/:bankUeid/application',
  registration: '/ui/registration',
  authorization: '/ui/authorization',
  passwordRecovery: '/ui/passwordRecovery',
  changePassword: '/ui/changePassword',
  phoneConfirm: '/ui/phoneConfirm',
  agent: '/ui/agent',
  organization: '/ui/agent/:organizationUeid',
  accountProfile: '/ui/accountProfile',
  emailConfirmation: '/ui/email-confirmation',
  acceptInvitation: '/ui/accept-invitation',
  addOrganization: '/ui/add-organization',
  addBank: '/ui/:organizationUeid/add-bank',
  merchants: '/ui/:organizationUeid/banks/:bankUeid/merchants',
  offer: '/ui/offer',
  offer_01_08_2023: '/ui/offer_01-08-2023',
  help: '/ui/help',
  privacyPolicy: '/ui/privacyPolicy',
  cookiePolicy: '/ui/cookiePolicy',
  notPartnerBanks: '/ui/notPartnerBanks',
};
